module.exports = __webpack_public_path__ + "img/Jump Casting127.22397f34.jpg";